import { render, staticRenderFns } from "./ModalReservaDeSala.vue?vue&type=template&id=d5ecead0"
import script from "./ModalReservaDeSala.vue?vue&type=script&lang=ts"
export * from "./ModalReservaDeSala.vue?vue&type=script&lang=ts"
import style0 from "./ModalReservaDeSala.vue?vue&type=style&index=0&id=d5ecead0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports